import React, { Component } from 'react';
import { sendSocialEvent, sendDataLayerEvent } from '../../utils/analytics';
import PropTypes from 'prop-types';
import { stringify } from 'querystring';
import { SVGs } from './fa_icons';

const PAGE_MODULE_MAP = {
  'header': 'Header',
  'image-shares': 'Image Share'
};

export default class SocialIcon extends Component {
  handleClick = (event) => {
    event.preventDefault();
    const {
      category, action, parentClass, url_full, socialURL, windowName, title
    } = this.props;

    sendSocialEvent(category, action, url_full);

    sendDataLayerEvent('Click', {
      socialLinkType: category,
      pageModule: PAGE_MODULE_MAP[parentClass] || 'Share',
      linkType: 'Social',
      linkURL: socialURL,
      itemName: title || category
    });

    window.open(socialURL, windowName, stringify({
      status: 'no',
      resizable: 'yes',
      scrollbars: 'yes',
      personalbar: 'no',
      directories: 'no',
      location: 'no',
      toolbar: 'no',
      menubar: 'no',
      width: 765,
      height: 270,
      left: 0,
      top: 0
    }));
  };

  render = () =>
    <button onClick={this.handleClick}
      className={`fa fa-${this.props.faClassName}`}
      dangerouslySetInnerHTML={{ __html: SVGs[this.props.faClassName] }}
      title={this.props.title}
      aria-label={this.props.title}
    />
}

SocialIcon.propTypes = {
  action: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  faClassName: PropTypes.string.isRequired,
  socialURL: PropTypes.string.isRequired,
  url_full: PropTypes.string.isRequired,
  windowName: PropTypes.string.isRequired,
  title: PropTypes.string,
  parentClass: PropTypes.string
};

SocialIcon.defaultProps = {
  action: '',
  category: '',
  faClassName: '',
  socialURL: '',
  url_full: '',
  windowName: '_blank',
  title: ''
};
